<section class="client-management">
    <div class="row">
        <div class="col-md-12">
            <!-- <app-breadcrumb [routePath2]="'/selling-catalog'" [title]="'ORDERMANAGEMENT.SellingCatalogMenu'"
                [title2]="'ORDERMANAGEMENT.SellingCatalogDetails'">
            </app-breadcrumb> -->

            <app-breadcrumb [routePath2]="'/selling-catalog'" 
            [title2]="'ORDERMANAGEMENT.SellingCatalogMenu'" [title3]="title">
        </app-breadcrumb>

        </div>
        <div class="col-md-12">
            <div class="common-tabbing">
                <div class="table-content box-style company-info">
                    <div class="table-heading">
                        <h3 style="font-weight: 600"> {{sellingCatalogName}}

                        </h3>
                        <div class="search-form-wrapper">
                            <button class="btn-style" (click)="redirectToOrder()">
                                <span class="material-icons">add</span>{{'ORDERMANAGEMENT.MANAGEORDERS.AddOrder'| translate}}
                            </button>

                        </div>
                    </div>
                    <div class="table-wrapper resource-color-table">
                        <!-- <h5 style="font-weight: 600">{{'ORDERMANAGEMENT.CatalogName'| translate}} :
                            {{sellingCatalogName}}

                        </h5> -->
                        <br/>
                        <table class="example-table mat-elevation-z8" mat-table recycleRows style="width: 100%"
                            [dataSource]="ServiceCatalogList">
                            <!-- Position Column -->
                            <!-- <ng-container matColumnDef="Code Id">
                                <th mat-header-cell *matHeaderCellDef>{{"ORDERMANAGEMENT.CODE_ID"
                                    | translate
                                    }} </th>
                                <td mat-cell *matCellDef="let element">{{element?.codeId ? element?.codeId :
                                    '-'}}
                                </td>
                            </ng-container> -->

                            <!-- Name Column -->
                            <ng-container matColumnDef="Item Name">
                                <th mat-header-cell *matHeaderCellDef
                                    style="white-space: nowrap;text-transform: capitalize;">
                                    {{"ORDERMANAGEMENT.ItemName" | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element"
                                    style="white-space: break-spaces;text-transform: capitalize;">
                                    <!-- {{element.sellingCatalogDetails.unitName ? element.sellingCatalogDetails.unitName :
                                    '-' }} -->
                                    {{
                        (element.sellingCatalogDetails?.unitName ||
                        element.sellingCatalogDetails?.taskName ||
                        element.sellingCatalogDetails?.macroTaskName) ? element.sellingCatalogDetails?.unitName ||
                        element.sellingCatalogDetails?.taskName ||
                        element.sellingCatalogDetails?.macroTaskName : '-'}} 
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Type"
                                style="white-space: break-spaces;text-transform: capitalize;">
                                <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;">
                                    {{"ORDERMANAGEMENT.Type"
                                    | translate }} </th>
                                <td mat-cell *matCellDef="let element" style="white-space: nowrap;">
                                    {{ getCatalogType(element?.catalogType || element?.sellingCatalogType) | translate }} </td>
                            </ng-container>

                            <!-- Weight Column -->
                            <ng-container matColumnDef="Fixed Price">
                                <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;">
                                    {{"ORDERMANAGEMENT.Price"
                                    | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element" style="white-space: nowrap;">
                                    <ng-container *ngIf="!element.sellingCatalogDetails.fixedVariablePrice">
                                        -
                                    </ng-container>
                                    <ng-container *ngIf="element.sellingCatalogDetails.fixedVariablePrice ==1">
                                        {{ 'ORDERMANAGEMENT.FixedPrice' | translate }}
                                    </ng-container>

                                    <ng-container *ngIf="element.sellingCatalogDetails.fixedVariablePrice ==2">
                                        {{ 'ORDERMANAGEMENT.VariablePrice' | translate }}
                                    </ng-container>
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="Customer Price">
                                <th mat-header-cell *matHeaderCellDef>{{"ORDERMANAGEMENT.CatalogPrice" |
                                    translate
                                    }} </th>
                                <td mat-cell *matCellDef="let element" style="white-space: nowrap;">
                                    {{element?.customerPrice ? (element?.customerPrice | customCurrency) : '-'}}
                        
                                </td>

                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                    {{"ORDERMANAGEMENT.NoRecordFound" | translate }}
                                </td>
                            </tr>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    </div>
</section>